import mutationsTypes from '@/store/mutationTypes'

const Mutations = {
  [mutationsTypes.SHOP_SET_SHOP_LIST]: (state, payload) => {
    state.shopList = payload.data.shopList

    const sortNumberList = payload.data.shopList.map((ele) => {
      return ele.sortNumber
    })

    if (sortNumberList.length) {
      state.maxSortNumber = Math.max(...sortNumberList)
    }
  }
}

export default Mutations
